var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('VueRecaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.siteKey,"size":"invisible"},on:{"verify":_vm.onCaptchaVerified,"expired":_vm.resetRecaptcha}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }